import React, { Component } from 'react';
import { connectHits } from "react-instantsearch-dom";
// UI
import Grid from "@material-ui/core/Grid";
import DetailedCarCard from "../../DetailedCarCard";
import TestDriveCard from "../../TestDriveCard";
import { appStyle } from '../../../theme/appStyle';
import { withStyles } from "@material-ui/core";

class AlgoliaHits extends Component {
    render() {
        const { hits } = this.props;
        const testDrivePosition = 4; // Position where to insert the test drive card

        // Create a new array with the test drive card inserted at the specified position
        const itemsWithTestDrive = [];
        hits.forEach((hit, index) => {
            itemsWithTestDrive.push(
                <Grid item xs={12} sm={6} md={6} lg={3} xl={3} key={hit.rom_ref || `key-${index}-${hit.configuration_id}`}>
                    <DetailedCarCard data={hit} />
                </Grid>
            );

            // Insert test drive card after the specified position
            if (index === testDrivePosition) {
                itemsWithTestDrive.push(
                    <Grid item xs={12} sm={6} md={6} lg={3} xl={3} key="test-drive-card">
                        <TestDriveCard />
                    </Grid>
                );
            }
        });

        return itemsWithTestDrive;
    }
}

AlgoliaHits = withStyles(appStyle)(AlgoliaHits);
AlgoliaHits = connectHits(AlgoliaHits);
export default AlgoliaHits;
